/* eslint-disable */
import { useQuery } from '@apollo/client';
import type { Data } from '../models/dealer';
import { BY_GEOLOCATION } from '../utils/graphql/dealers';
import { toISO3CountryCode } from '../utils/i18n';

export default function useSearchByGeoLocation(
  radiusInKm: number,
  lat: number,
  lng: number,
  countryCode?: string,
  filters?: string[],
  userLat?: number,
  userLng?: number,
) {
  const { error, data, loading } = useQuery<
    Data,
    {
      lat: number;
      lng: number;
      userLat?: number;
      userLng?: number;
      radius: number;
      country?: string;
      services?: string;
    }
  >(BY_GEOLOCATION, {
    fetchPolicy: 'no-cache',
    variables: {
      lat,
      lng,
      radius: radiusInKm,
      ...(countryCode && { country: toISO3CountryCode(countryCode) }),
      ...(filters && filters.length > 0 && { services: filters.join() }),
      userLat,
      userLng,
    },
    context: {
      headers: {
        alwaysReturnPartner: true,
      },
    },
    skip: (lat === 0 && lng === 0) || radiusInKm <= 0,
  });

  return {
    error,
    loading,
    dealersResult: data?.dealersByGeoLocation.dealers,
    searchRadius: data?.dealersByGeoLocation.meta?.searchRadius,
  };
}
